import { render, staticRenderFns } from "./InformationDisasterPrevent.vue?vue&type=template&id=670e1965&scoped=true"
import script from "./InformationDisasterPrevent.vue?vue&type=script&lang=js"
export * from "./InformationDisasterPrevent.vue?vue&type=script&lang=js"
import style0 from "./InformationDisasterPrevent.vue?vue&type=style&index=0&id=670e1965&prod&scoped=true&lang=css"
import style1 from "./InformationDisasterPrevent.vue?vue&type=style&index=1&id=670e1965&prod&lang=css"
import style2 from "./InformationDisasterPrevent.vue?vue&type=style&index=2&id=670e1965&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670e1965",
  null
  
)

export default component.exports